import React, { useEffect, useState } from 'react';
import axios from 'axios';

function App() {
  const [sport, setSport] = useState('mlb');
  const [games, setGames] = useState([]);

  useEffect(() => {
    const url =
      sport === 'mlb'
        ? 'http://localhost:8000/mlb/odds'
        : 'http://localhost:8000/football/odds';

    axios.get(url)
      .then(res => setGames(res.data))
      .catch(err => {
        console.error(err);
        setGames([]);
      });
  }, [sport]);

  return (
    <div style={{ padding: 20, fontFamily: 'sans-serif' }}>
      <h1 style={{ textAlign: 'center', fontSize: 36 }}>kkrt Test</h1>

      <div style={{ textAlign: 'center', margin: '20px 0' }}>
        <select
          value={sport}
          onChange={e => setSport(e.target.value)}
          style={{ fontSize: 16, padding: '4px 8px' }}
        >
          <option value="mlb">MLB (야구)</option>
          <option value="football">K리그 1 (축구)</option>
        </select>
      </div>

      <table
        border="1"
        cellPadding="8"
        style={{ width: '100%', borderCollapse: 'collapse' }}
      >
        <thead>
          <tr style={{ background: '#eee' }}>
            <th>Teams</th>
            <th>Date</th>
            <th>Bookmaker</th>
            {sport === 'mlb' ? (
              <>
                <th>Home Odds</th>
                <th>Away Odds</th>
              </>
            ) : (
              <>
                <th>Home</th>
                <th>Draw</th>
                <th>Away</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {games.length === 0 ? (
            <tr>
              <td colSpan={sport === 'mlb' ? 5 : 6} style={{ textAlign: 'center' }}>
                데이터가 없습니다.
              </td>
            </tr>
          ) : (
            games.map((g, i) => {
              const bm = g.bookmakers[0];
              const outcomes = bm?.markets[0]?.outcomes || [];
              return (
                <tr key={i}>
                  <td>{`${g.home_team} vs ${g.away_team}`}</td>
                  <td>{new Date(g.commence_time).toLocaleString()}</td>
                  <td>{bm?.title || '-'}</td>
                  {sport === 'mlb' ? (
                    <>
                      <td>{
                        outcomes.find(o => o.name === g.home_team)?.price ?? '-'
                      }</td>
                      <td>{
                        outcomes.find(o => o.name === g.away_team)?.price ?? '-'
                      }</td>
                    </>
                  ) : (
                    <>
                      <td>{
                        outcomes.find(o => o.name === g.home_team)?.price ?? '-'
                      }</td>
                      <td>{
                        outcomes.find(o => o.name === 'Draw')?.price ?? '-'
                      }</td>
                      <td>{
                        outcomes.find(o => o.name === g.away_team)?.price ?? '-'
                      }</td>
                    </>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}

export default App;
